import { render, staticRenderFns } from "./List-Villages.vue?vue&type=template&id=13485598"
import script from "./List-Villages.vue?vue&type=script&lang=js"
export * from "./List-Villages.vue?vue&type=script&lang=js"
import style0 from "./List-Villages.vue?vue&type=style&index=0&id=13485598&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports